export default __webpack_public_path__ + "static/RunLeft4-3193c435c1d2a5595113747fad7949c2.mp3";